import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import RouteWrapper from "./components/RouteWrapper";

import AccountConfirmation from "./components/Actor/AccountConfirmation";
import AccountConfirmed from "./components/Actor/AccountConfirmed";
import ConfirmEmailComponent from "./components/Common/ConfirmEmailComponent";
import FailConfirmEmailComponent from "./components/Common/FailConfirmEmailComponent";

import Registration from "./components/Registration";
import CastingFilmCenterStep from "./components/Director/CastingFilmCenterStep";
import CastingAccessStep from "./components/Director/CastingAccessStep";
import CastingAssociationsStep from "./components/Director/CastingAssociationsStep";
import CastingProAccountStep from "./components/Director/CastingProAccountStep";
import CastingLimitedAccountStep from "./components/Director/CastingLimitedAccountStep";
import SuccessSignUpBizhours from "./components/Common/SuccessSignUpBizhours";
import ActorStageNameStep from "./components/Actor/SignUp/ActorStageNameStep";
import ActorFilmCenterStep from "./components/Actor/SignUp/ActorFilmCenterStep";
import ActorTrialFilmCenterStep from "./components/Actor/SignUp/Trial/Special/ActorTrialFilmCenterStep";
import ActorCodeFilmCenterStep from "components/Actor/SignUp/Trial/Code/ActorCodeFilmCenterStep";
import ActorOfferFilmCenterStep from "components/Actor/SignUp/ActorOfferFilmCenterStep";
import ActorRegistrationUpgradeTable from "./components/Actor/SignUp/ActorRegistrationUpgradeTable";
import ActorRegistrationComplete from "./components/Actor/ActorRegistrationComplete";
import ActorTrailRegistrationComplete from "./components/Actor/SignUp/Trial/ActorTrailRegistrationComplete";
import ActorCodeRegistrationComplete from "components/Actor/SignUp/Trial/Code/ActorCodeRegistrationComplete";
import ActorPaymentStep from "./components/Actor/SignUp/ActorPaymentStep";
import ActorPaymentProcessing from "./components/Actor/ActorPaymentProcessing";
import ActorPaymentDeclined from "./components/Actor/ActorPaymentDeclined";
import ActorUpgradeSpecial from "./components/Actor/Upgrade/ActorUpgradeSpecial";
import ActorUpgradeTable from "./components/Actor/Upgrade/ActorUpgradeTable";
import ActorUpgradePayment from "./components/Actor/Upgrade/ActorUpgradePayment";
import ActorUpgradeComplete from "./components/Actor/Upgrade/ActorUpgradeComplete";
import ActorUpgradeProductComplete from "components/Actor/Upgrade/ActorUpgradeProductComplete";
import StripeActorPaymentWrapper from "./components/Actor/StripeActorPaymentWrapper";
import ActorTrialDetail from "./components/Actor/SignUp/Trial/ActorTrialDetail";
import TrialActorApp from "./components/Actor/SignUp/Trial/TrailActorApp";

import ActorInvitation from "components/Actor/SignUp/ActorInvitation";

import ActorCreateVerifyStep from "components/Actor/SignUp/ActorCreateVerifyStep";

import AcademyUserTypeSelect from "./components/Academy/UserTypeSelect";

import UserTypeSelect from "./components/CWBLabs/UserTypeSelect";
import ActorSignUp from "./components/CWBLabs/ActorSignUp";
import ActorTrialSignUp from "./components/Actor/SignUp/Trial/Special/ActorTrialSignUp";
import ActorCodeSignUp from "./components/Actor/SignUp/Trial/Code/ActorCodeSignUp";
import PerformerSignUp from "./components/CWBLabs/PerformerSignUp";
import SignUpSuccess from "./components/CWBLabs/SignUpSuccess";
import SignUpFailure from "./components/CWBLabs/SignUpFailure";
import ActorPaymentDetails from "./components/Actor/ActorPaymentDetails";
import BridgeAuthRoute from "./components/BridgeAuthRoute";
import BridgeAuthOptionalRoute from "./components/BridgeAuthOptionalRoute";
import SeamlessAuthRoute from "./components/SeamlessAuthRoute";
import OfferNotValid from "components/Common/OfferNotValid";
import NotAvailable from "components/Common/NotAvailable";
import ActorVerifyPhoneStepHOC from "components/Actor/SignUp/ActorVerifyPhoneStepHOC";
import ActorPaymentRequiresAction from "components/Actor/ActorPaymentRequiresAction";
import RegistrationSimple from "components/RegistrationSimple";
import ActorResumeSignup from "components/Actor/SignUp/ActorResumeSignup";
import RouteWithCanonical from "components/RouteWithCanonical";
import ProtectedRoute from "./components/ProtectedRoute";
import OnboardingComponent from "./components/Onboarding/OnboardingComponent";
import TalentSignup from "./components/Talent/TalentSignup";

import SubmissionRoute from "./components/SubmissionRoute";
import BoostLandingPage from "./components/Submission/pages/BoostLandingPage";
import CastingCallsPage from "./components/Submission/pages/CastingCallsPage";
import BreakdownClosedPage from "./components/Submission/pages/BreakdownClosedPage";
import SubmissionWizardShell from "./components/Submission/pages/SubmissionWizardShell";
import SignupFormPage from "./components/Submission/pages/SignupFormPage";
import SignupVerifyEmailPage from "./components/Submission/pages/SignupVerifyEmailPage";
import SubmissionContinuePage from "./components/Submission/pages/SubmissionContinuePage";
import SubmitMaterialsPage from "./components/Submission/pages/SubmitMaterialsPage";
import PhoneVerificationPage from "./components/Submission/pages/PhoneVerificationPage";
import SubmissionSavedPage from "./components/Submission/pages/SubmissionSavedPage";
import SubmissionUnsubscribePage from "./components/Submission/pages/SubmissionUnsubscribePage";
import SubmissionReviewPage from "./components/Submission/pages/SubmissionReviewPage";
import PaywallPage from "./components/Submission/pages/PaywallPage";
import MockStripeCheckoutPage from "./components/Submission/pages/MockStripeCheckoutPage";
import CheckoutReturnPage from "./components/Submission/pages/CheckoutReturnPage";
import SubmissionSentPage from "./components/Submission/pages/SubmissionSentPage";
import MockDashboardPage from "./components/Submission/pages/MockDashboardPage";
import MockSeedPage from "./components/Submission/pages/MockSeedPage";
import MockLoginPage from "./components/Submission/pages/MockLoginPage";
import MockOutcomesPage from "./components/Submission/pages/MockOutcomesPage";
import { withSubmissionEvent, withSubmissionReturn } from "./components/Submission/common/CheckoutReturnGate";
import { classicBreakdownSearch, legacyBreakdownEntry, submissionFlowOn } from "./components/Submission/common/legacyEntry";

// A purchase that started in the submission flow goes back to step 4 from here;
// everyone else gets the completion page as before (docs/30 §6).
const ProCompletedPage = withSubmissionReturn(ActorRegistrationComplete);
const UpgradeCompletedPage = withSubmissionReturn(ActorUpgradeComplete, "sf_pro_paid");

// The classic upgrade pages an actor with no trial goes through from step 4: their events, only
// for a visit from the flow (docs/35 S4). The pages themselves are unchanged.
const ProPlansPage = withSubmissionEvent(ActorUpgradeTable, "sf_pro_plans_viewed");
const ProCheckoutPage = withSubmissionEvent(ActorUpgradePayment, "sf_pro_checkout_viewed");
const PaymentDeclinedPage = withSubmissionEvent(ActorPaymentDeclined, "sf_step_failed", { step: "pro_checkout", reason: "card_declined" });

const removeLabs: any = (search: string) => {
  let qs = new URLSearchParams(search);
  qs.delete('cwblabs');
  return qs.toString();
}

const Routes: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <BridgeAuthRoute
          path="/actor/payment/details"
          component={ActorPaymentDetails}
        />
        <Route
          exact
          path="/onboarding"
          render={() => (
            <ProtectedRoute>
              <OnboardingComponent />
            </ProtectedRoute>
          )}
        />
        <Route
          exact
          path="/"
          render={(routeProps) => (
            <Redirect
              to={{
                pathname: "/register",
                search: window.location.search,
              }}
            />
          )}
        />
        <RouteWrapper
          exact
          path="/register/offer-not-valid"
          component={OfferNotValid}
        />
        <RouteWrapper
          exact
          path="/not-available"
          component={NotAvailable}
        />

        <Route strict exact path="/register/" render={(routeProps) => {
          return (<Redirect to={{ pathname: "/register", search: routeProps.location.search }} />)
        }
        } />

        <RouteWrapper exact path="/register" component={Registration} />
        <RouteWrapper exact path="/actor" component={RegistrationSimple} />
        <RouteWrapper exact path="/microdrama" component={TalentSignup} />

        {/* New submission-first signup flow ("Golden Path") — mock-first,
            parallel to the legacy wizard. Mobile + desktop split screen.
            See docs/12 + docs/13. */}
        {/* Bare entry points carry no breakdown, so there is nothing to submit
            to — hand them to the standard actor signup, keeping the query.
            `exact` without `strict` also covers the trailing-slash form.
            (react-router 4.3 has no array-path support, hence two routes.) */}
        <Route
          exact
          path="/submission"
          render={(routeProps) => (
            <Redirect
              to={{ pathname: "/register/actor", search: routeProps.location.search }}
            />
          )}
        />
        <Route
          exact
          path="/submission/flow"
          render={(routeProps) => (
            <Redirect
              to={{ pathname: "/register/actor", search: routeProps.location.search }}
            />
          )}
        />
        <SubmissionRoute exact path="/submission/boost" component={BoostLandingPage} />
        <SubmissionRoute exact path="/submission/casting-calls" component={CastingCallsPage} />
        <SubmissionRoute exact path="/submission/casting-calls/:ctry([A-Za-z]{2})" component={CastingCallsPage} />
        <SubmissionRoute exact path="/submission/closed" component={BreakdownClosedPage} />
        <SubmissionRoute exact path="/submission/saved" component={SubmissionSavedPage} />
        <SubmissionRoute exact path="/submission/unsubscribe" component={SubmissionUnsubscribePage} />
        <SubmissionRoute exact path="/submission/flow/step/1" component={SignupFormPage} />
        <SubmissionRoute exact path="/submission/flow/verify-email" component={SignupVerifyEmailPage} />
        <SubmissionRoute exact path="/submission/flow/continue" component={SubmissionContinuePage} />
        <SubmissionRoute exact path="/submission/flow/step/2" component={SubmitMaterialsPage} />
        <SubmissionRoute exact path="/submission/flow/step/3" component={PhoneVerificationPage} />
        <SubmissionRoute exact path="/submission/flow/step/4" component={SubmissionReviewPage} />
        <SubmissionRoute exact path="/submission/paywall" component={PaywallPage} />
        <SubmissionRoute exact path="/submission/checkout" component={MockStripeCheckoutPage} />
        <SubmissionRoute exact path="/submission/checkout/return" component={CheckoutReturnPage} />
        <SubmissionRoute exact path="/submission/sent" component={SubmissionSentPage} />
        <SubmissionRoute exact path="/submission/mock-dashboard" component={MockDashboardPage} />
        <SubmissionRoute exact path="/submission/mock-seed" component={MockSeedPage} />
        <SubmissionRoute exact path="/submission/mock-login" component={MockLoginPage} />
        <SubmissionRoute exact path="/submission/mock-outcomes" component={MockOutcomesPage} />
        {/* Anything else under step/N — a hand-typed step/9, a stale link — still
            lands somewhere, so this stays last. */}
        <SubmissionRoute exact path="/submission/flow/step/:step" component={SubmissionWizardShell} />
        <RouteWithCanonical exact path="/register/performer" component={PerformerSignUp} />
        {/* <RouteWrapper path="/register/cwblabs/actor" component={ActorSignUp} /> */}
        <Route
          path="/register/cwblabs/actor"
          render={(routeProps) => (
            <Redirect
              to={{
                pathname: "/register/actor",
                search: removeLabs(routeProps.location.search),
              }}
            />
          )}
        />
        {/* <RouteWrapper path="/register/special/actor" component={ActorTrialSignUp} /> */}
        <Route
          path="/register/special/actor"
          render={(routeProps) => {

            // A breakdown link (open-breakdown.asp's apply button, the login
            // page's registerTrial) enters the submission flow. See legacyEntry.
            // REACT_APP_SUBMISSION_FLOW=off (a rebuild, no code change) sends it to
            // the classic wizard instead, as before the flow.
            const submission = submissionFlowOn()
              ? legacyBreakdownEntry(routeProps.location.search)
              : null;
            if (submission) {
              return <Redirect to={submission} />;
            }
            const target = classicBreakdownSearch(routeProps.location.search);

            return (
              <Redirect
                to={{
                  pathname: "/register/actor",
                  search: target,
                }}
              />
            )
          }
          }
        />
        <RouteWrapper path="/email/confirmed" render={(routeProps) => (<ConfirmEmailComponent {...routeProps} disableSignIn={true} />)} />
        {/* <RouteWrapper path="/register/trial/actor" component={ActorCodeSignUp} /> */}
        <Route
          path="/register/trial/actor"
          render={(routeProps) => (
            <Redirect
              to={{
                pathname: "/register/actor",
                search: removeLabs(routeProps.location.search),
              }}
            />
          )}
        />
        <RouteWrapper path="/register/:accountType?" component={Registration} />
        <RouteWithCanonical
          path="/academy/select-account-type"
          component={AcademyUserTypeSelect}
        />
        <RouteWithCanonical path="/select-account-type" component={UserTypeSelect} />
        <RouteWrapper path="/casting/1" component={CastingFilmCenterStep} />
        <RouteWrapper
          path="/casting/2"
          render={(routeProps) => <CastingAccessStep {...routeProps} />}
        />
        <RouteWrapper
          path="/casting/select-associations"
          component={CastingAssociationsStep}
        />
        <RouteWrapper path="/casting/pro" component={CastingProAccountStep} />
        <RouteWrapper
          path="/casting/limited"
          component={CastingLimitedAccountStep}
        />
        <RouteWrapper
          isCompleted
          path="/agent/completed"
          render={(routeProps) => <SuccessSignUpBizhours {...routeProps} />}
        />
        <RouteWrapper path="/invitation/:id" component={ActorInvitation} />
        {/* <RouteWrapper path="/invitation/:id/1" component={ActorCreateVerifyStep} />
        <RouteWrapper path="/invitation/:id/2" component={ActorCreateVerifyStep} /> */}
        <RouteWrapper path="/actor/1/emailConfirm" component={ActorCreateVerifyStep} />
        <RouteWrapper path="/actor/1/confirmEmail" component={ActorCreateVerifyStep} />
        <RouteWrapper path="/actor/1" component={ActorCreateVerifyStep} />
        <RouteWrapper path="/actor/2" component={ActorVerifyPhoneStepHOC} />
        <RouteWrapper path="/actor/3" component={ActorStageNameStep} />
        <RouteWrapper path="/actor/4" component={ActorFilmCenterStep} />
        <RouteWrapper
          path="/actor/special/4"
          component={ActorTrialFilmCenterStep}
        />
        <RouteWrapper
          path="/actor/trial/4"
          component={ActorCodeFilmCenterStep}
        />
        <RouteWrapper
          path="/actor/offer/4"
          component={ActorOfferFilmCenterStep}
        />
        <BridgeAuthOptionalRoute
          path="/actor/5"
          component={ActorRegistrationUpgradeTable}
        />
        <RouteWrapper path="/actor/trial-detail" component={ActorTrialDetail} />
        <RouteWrapper
          isCompleted
          path="/actor/free-trial/completed"
          render={(routerProps) => (
            <ActorTrailRegistrationComplete {...routerProps} />
          )}
        />
        <RouteWrapper
          path="/actor/service-code/completed"
          isCompleted
          render={(routerProps) => (
            <ActorCodeRegistrationComplete {...routerProps} />
          )}
        />
        <RouteWrapper
          path="/trial-actor-app"
          render={(routerProps) => <TrialActorApp {...routerProps} />}
        />
        <RouteWrapper
          path="/actor/free-completed"
          isCompleted
          render={(routerProps) => (
            <ActorRegistrationComplete free {...routerProps} />
          )}
        />
        <RouteWrapper
          path="/actor/payment"
          render={(routerProps) => (
            <StripeActorPaymentWrapper>
              <ActorPaymentStep {...routerProps} />
            </StripeActorPaymentWrapper>
          )}
        />
        <RouteWrapper
          path="/actor/resume"
          component={ActorResumeSignup}
        />
        <RouteWrapper
          path="/actor/payment-processing"
          component={ActorPaymentProcessing}
        />
        <RouteWrapper
          path="/actor/payment-action"
          component={ActorPaymentRequiresAction}
        />
        <RouteWrapper
          path="/actor/payment-declined"
          component={PaymentDeclinedPage}
        />
        <RouteWrapper
          isCompleted
          path="/actor/pro-completed"
          component={ProCompletedPage}
        />
        <RouteWrapper
          isCompleted
          path="/actor/pro-renewed"
          render={(routerProps: any) => <ActorRegistrationComplete {...routerProps} isRenewed={true} />}
        />
        <RouteWrapper
          isCompleted
          path="/actor/completed"
          render={(routerProps) => <SuccessSignUpBizhours {...routerProps} />}
        />
        <SeamlessAuthRoute
          isUpgrade
          path="/actor/upgrade-special"
          component={ActorUpgradeSpecial}
        />
        <SeamlessAuthRoute
          isUpgrade
          path="/actor/upgrade-to-premium"
          component={ActorUpgradeTable}
        />
        <SeamlessAuthRoute
          isUpgrade
          path="/actor/upgrade-to-pro"
          component={ProPlansPage}
        />
        <SeamlessAuthRoute
          path="/actor/select-membership"
          isUpgrade
          trialCheck
          render={(routerProps) => (
            <StripeActorPaymentWrapper>
              <ProCheckoutPage {...routerProps} />
            </StripeActorPaymentWrapper>
          )}
        />
        <SeamlessAuthRoute
          isUpgrade
          isCompleted
          path="/actor/upgrade-completed"
          component={UpgradeCompletedPage}
        />
        <SeamlessAuthRoute
          isUpgrade
          isCompleted
          path="/actor/homekit-completed"
          component={ActorUpgradeProductComplete}
        />
        <RouteWrapper
          path="/actor/account-confirmation"
          render={(routerProps) => <AccountConfirmation {...routerProps} />}
        />
        <RouteWrapper
          path="/actor/account-confirmed"
          render={(routerProps) => <AccountConfirmed {...routerProps} />}
        />
        <RouteWithCanonical path="/performer/completed" component={SignUpSuccess} />
        <RouteWithCanonical path="/performer/failed" component={SignUpFailure} />
        <RouteWrapper
          path="/account-confirmed"
          render={(routerProps) => <ConfirmEmailComponent {...routerProps} disableSignIn={false} />}
        />
        <RouteWrapper
          path="/failConfirm"
          render={(routerProps) => (
            <FailConfirmEmailComponent {...routerProps} />
          )}
        />
        <Route
          render={() => {
            window.location.replace(process.env.REACT_APP_CWB_Site);
            return null;
          }}
        />
      </Switch>
    </>
  );
};

export default Routes;
